import React, { useEffect, useState } from "react";
import { Button, IconDownload, Table, Search, Select } from "@veneer/core";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import moment from "moment";
import {
  numberFormatComma,
  numberFormatCommaTwoFraction,
} from "../../../common/js/utils/numberFormat";
import XLSX from "xlsx";
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import { data } from "jquery";
import { number } from "yup";

const DetailsStatement = (props) => {
  let totalBonus = 0;
  const { t, i18n } = useTranslation();
  const [channelFilterValue, setChannelFilterValue] = useState("");
  const [endUserFilterValue, setEndUserFilterValue] = useState("");
  const [regionFilterValue, setRegionFilterValue] = useState("");
  const [first,setfirst]=useState(true);
  const configCompensationColums = [
    {
      id: "dateFormatted",
      label: "Date"
    },
    {
      id: "customerName",
      label: "Channel"
    },
    {
      id: "endUserNameLink",
      label: "Client"
    },
    { id: "tpiCompensationFormatted", label: "TPI-1SEP-2SEP-3SEP" },
    {
      id: "serviceArea",
      label: "Region"
    },
    { id: "compensationClientFormatted", label: "Compen- sation Client" },
    { id: "compensationChannelFormatted", label: "Compen- sation Channel" },
    { id: "compensationAccepted", label: "Compen- sation Accepted" },
  ];

  const configBonus = [
    {
      id: "dateFormatted",
      label: t("month"),
    },
    {
      id: "customerName",
      label: <Trans i18nKey="channel" />
    },
    {
      id: "endUserNameLink",
      label: <Trans i18nKey="Client" />,
      index: true
    },
    {
      id: "tpiBonusFormatted",
      label: "TPI-1SEP-2SEP-3SEP"
    },
    {
      id: "bonusAmountFormatted",
      label: <Trans i18nKey="bonus" />
    },
    { id: "priceFormatted", label: <Trans i18nKey="price" />, index: true },
    {
      id: "creditNoteLastPublicationFormatted",
      label: "CN on last publication",
    },
    {
      id: "releasedLastPublicationFormatted",
      label: "CN released on last publication"
    },
    {
      id: "releasedPreviousPublicationFormatted",
      label: "CN released from previous publication"
    },
    {
      id: "creditNoteTotalFormatted",
      label: "Credit note total"
    },
    {
      id: "onHoldLastPublicationFormatted",
      label: "CN on hold on last publication"
    },
    {
      id: "onHoldPreviousPublicationFormatted",
      label: "CN on hold from previous publication"
    },
    {
      id: "creditNoteOnHoldTotalFormatted",
      label: "CN on hold Total"
    },
    {
      id: "bonusAccepted",
      label: <Trans i18nKey="bonus accepted" />,
    },
    {
      id: "bonusPaid",
      label: <Trans i18nKey="bonus paid" />,
    },
    {
      id: "specialCondition",
      label: <Trans i18nKey="special condition" />,
    },
    {
      id: "bonusReleasedLastPublication",
      label: <Trans i18nKey="bonus released last publication" />,
    },
    {
      id:"bonusOnHoldLastPublication",
      label:  <Trans i18nKey="bonus on hold last publication"/>
    },
    {
      id:"bonusReleasedPreviousPublication",
      label:  <Trans i18nKey="bonus release previous publication"/>
    },
    {
      id:"bonusOnHoldPreviousPublication",
      label: <Trans i18nKey="bonus on hold previous publication"/>
    },
    {
      id:"bonusOnHoldTotal",
      label:<Trans i18nKey="bonus on hold total"/>
    },
    {
      id:"bonusTotal",
      label:<Trans i18nKey="bonus total"/>
    },
    {
      id: "serviceArea",
      label: <Trans i18nKey="region" />
    },
  ];

  const connectApi = new ConnectAPI();
  const { id } = props.match.params;
  const [cppType, setCppType] = useState("Bonus");
  const [datesView, setDatesView] = useState([]);
  const [dateSelected, setDateSelected] = useState();
  const [EndDateSelected, setEndDateSelected]=useState();
  const [channelSelected, setChannelSelected] = useState("whole");
  const [channelsView, setChannelsView] = useState([]);
  const [channels, setChannels] = useState([]);
  const [config, setConfig] = useState(configBonus);
  const [configCompensation, setConfigCompensation] = useState(
    configCompensationColums
  );
  const [dataResponse, setDataResponse] = useState();
  const [dataBonus, setDataBonus] = useState([]);
  const [compensationData, setCompensationData] = useState([]);
  const [compensationTotal, setCompensationTotal] = useState({
    client: 0,
    channel: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const [customerNameCompensation, setCustomerNameCompensation] = useState("");
  const [endUserNameCompensation, setEndUserNameCompensation] = useState("");
  const [serviceAreaCompensation, setServiceAreaCompensation] = useState("");
  const [order, setOrder] = useState(config.map((c) => c.id));
  const [orderCompensation, setOrderCompensation] = useState(
    configCompensationColums.map((c) => c.id)
  );
  const [groupBonusCustomers, setGroupBonusCustomers] = useState([]);
  const [groupCompensationCustomers, setGroupCompensationCustomers] = useState(
    []
  );
  const [bonusTotals, setBonusTotals] = useState();
  const [groupedCustomerRegionBonus, setGroupedCustomerRegionBonus] = useState([]);
  const [groupedCustomerRegionComp, setGroupedCustomerRegionComp] = useState([]);
  const [orderBy, setOrderBy] = useState("dateFormatted");
  const [orderType, setOrderType] = useState("descending");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentCompensationPage, setCurrentCompensationPage] = useState(1);
  const [currentMonthLabel, setCurrentMonthLabel] = useState('');
  const pageSize = 50;

  const exportData = () => {
    setLoadingExport(true);
    setTimeout(() => {
      let excelData = cppType == "Bonus" ? tableData : compensationData;
      const dataXlsx = excelData.map((item) => {
        if (cppType == "Bonus") {
          return {
            'Month': item.dateFormatted,
            'Channel': item.customerName,
            'End User': item.endUserName,
            'TPI': item.tpiBonus,
            'Bonus %': item.bonusAmount / 100,
            'Bonus Amount': item.price,
            'Credit note of the month': item.creditNoteLastPublication,
            'Credit note of the month released': item.releasedLastPublication,
            'Credit note released from previous publications': item.releasedPreviousPublication,
            'Credit note to be paid total': item.creditNoteTotal,
            'Credit note of the month on hold': item.onHoldLastPublication,
            'Credit note on hold from previous publications': item.onHoldPreviousPublication,
            'Credit note on hold total': item.creditNoteOnHoldTotal,
            'Bonus Accepted': item.bonusAccepted,
            'Bonus Paid': item.bonusPaid,
            'Special Condition': item.specialCondition,
            'Bonus Released Last Publication':parseFloat(item.bonusReleasedLastPublication.replace(/,/g, "")),
            'Bonus on Hold Last Publication':parseFloat(item.bonusOnHoldLastPublication.replace(/,/g, "")),
            'Bonus Released Previus Publication':parseFloat(item.bonusReleasedPreviousPublication.replace(/,/g, "")),
            'Bonus on Hold Previus Publication': parseFloat(item.bonusOnHoldPreviousPublication.replace(/,/g, "")),
            'Bonus on Hold Total':parseFloat(item.bonusOnHoldTotal.replace(/,/g, "")),
            'Bonus Total': parseFloat(item.bonusTotal.replace(/,/g, "")),
            'Region': item.serviceArea,
          };
        } else {
          return {
            date: item.dateFormatted,
            channel: item.customerName,
            customer: item.endUserName,
            tpi: item.tpiCompensation,
            region: item.serviceArea,
            compensationClient: item.compensationClient,
            compensationChannel: item.compensationChannel,
            compensationAccepted: item.compensationAccepted,
          };
        }
      });
      const ws = XLSX.utils.json_to_sheet(dataXlsx);
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format("YYYYMMDDHHmm");

      const filename =
        (cppType == "Bonus" ? "Bonus Report" : "Compensation Report") +
        " - " +
        date +
        ".xlsx";
      const ws_name =
        cppType == "Bonus" ? "Bonus Report" : "Compensation Report";

      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      if (channelSelected === 'whole' && dateSelected===EndDateSelected) {
        const dataToPrint = cppType == 'Bonus' ? formatGroupedBonusDataToExport() : formatGroupedCompDataToExport();
        const wsB = XLSX.utils.json_to_sheet(dataToPrint);
        const wsName = cppType == 'Bonus' ? 'Bonus per Channel-Region' : 'Compensation per Client-Region';
        XLSX.utils.book_append_sheet(wb, wsB, wsName);
      }

      XLSX.writeFile(wb, filename);

      setLoadingExport(false);
    }, 750);
  };

  function formatGroupedBonusDataToExport() {
    let data = [];
    groupedCustomerRegionBonus.forEach((elem, idx, arr) => {
      if (idx > 0 && arr[idx - 1].type === 'region') {
        data.push({
          'Customer/Region': "",
          'Bonus Amount': "",
          'Credit note of the month': "",
          'Credit note no be paid total': "",
          'Credit note on hold total': ""
        });
      }
      data.push({
        'Customer/Region': elem.id,
        'Bonus Amount': elem.price,
        'Credit note of the month': elem.creditNoteLastPublication,
        'Credit note to be paid total': elem.creditNoteTotal,
        'Credit note on hold total': elem.creditNoteOnHoldTotal
      });

    });

    return data;
  }

  function formatGroupedCompDataToExport() {
    let data = [];
    groupedCustomerRegionComp.forEach((elem, idx, arr) => {
      if (idx > 0 && arr[idx - 1].type === 'region') {
        data.push({ customerOrRegion: "", compensationClient: '' });
      }
      data.push({ customerOrRegion: elem.id, compensationClient: elem.compensationClient });

    });

    return data;
  }

  const handlePageChange = (page) => setCurrentPage(page);

  const handlePageCompensationChange = (page) =>
    setCurrentCompensationPage(page);

  const handleOnColumnReorder = (newOrder) => {
    cppType === "Compensation"
      ? setOrderCompensation(newOrder)
      : setOrder(newOrder);
  };
  const filteredData = filterSort(
    tableData,
    {
      customerName: channelFilterValue,
      endUserName: endUserFilterValue,
      serviceArea: regionFilterValue,
    },
    orderBy,
    orderType
  );
  

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  ).map(x => {
    if (x.endUserName != "Channel Manual Adjustment") {
      x.endUserNameLink = (
        <a href={"/cpp/report/" + x.idEndUser}>
          {x.endUserName}
        </a>
      );
      return x;
    } else {
      x.endUserNameLink = "Channel Manual Adjustment"
      return x;
    }
  });


  const filteredCompensationData = filterSort(
    compensationData,
    {
      customerName: customerNameCompensation,
      endUserName: endUserNameCompensation,
      serviceArea: serviceAreaCompensation,
    },
    orderBy,
    orderType
  );
 

  let pagedCompensationData = filteredCompensationData.slice(
    (currentCompensationPage - 1) * pageSize,
    (currentCompensationPage - 1) * pageSize + pageSize
  ).map(x => {
    x.endUserNameLink = (
      <a href={"/cpp/report/" + x.idEndUser}>
        {x.endUserName}
      </a>
    );
    return x;
  });
  
  function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter =
        typeof filterValue === "object" ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });
    // sort
    if (orderBy=="dateFormatted"){
      if (orderType=="descending"){
        return arrayFiltered.sort((a,b)=>{
           return new Date(b.dateFormatted).getTime()-new Date(a.dateFormatted).getTime();
        });
      }else{
        return arrayFiltered.sort((a,b)=>{
          return new Date(a.dateFormatted).getTime()-new Date(b.dateFormatted).getTime();
       });
      }
    }else if(orderBy=="endUserNameLink"){
      return arrayFiltered.sort((a, b) => {
        const value =
          orderType === "descending"
            ? descendingComparator(a, b, "endUserName")
            : -descendingComparator(a, b, "endUserName");
  
         return value;

      });
    }else{
      return arrayFiltered.sort((a, b) => {
        const value =
          orderType === "descending"
            ? descendingComparator(a, b, orderBy)
            : -descendingComparator(a, b, orderBy);
  
         return value;

      });
    }
    
  }

  function sort(array, orderBy, orderType) { 
    return array.sort((a, b) => {
      const value = (orderType === 'descending')
        ? descendingComparator(a, b, orderBy)
        : -descendingComparator(a, b, orderBy);
  
      return value;
    });
  }

  function descendingComparator(a, b, orderBy) {
    let aSort;
    let bSort;
    if (orderBy.endsWith("Formatted")) {
      orderBy = orderBy.substring(0, orderBy.length - "Formatted".length);
      aSort = a[orderBy];
      bSort = b[orderBy];
    } else {
      aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
      bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
    }

    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    const fetchData = () => {
      connectApi

        .get("api/Channels/reports/Dates/", "", datesLoad)
        .catch((error) => {
          Swal.fire(
            "Error " + error.response.status,
            error.response.data,
            "error"
          );
        });
    };

    const datesLoad = (status, data) => {
      const items = data.map((item) => {
        return {
          value: moment(item.date).format("YYYY-MM-DDTHH:mm:ss"),
          label:
            moment(item.date).format("MMM") +
            " " +
            moment(item.date).format("YYYY"),
        };
      });

      const date = items[0] === undefined ? null : items[0].value;
      const currentLabel = items[0] === undefined ? '' : items[0].label;
      setCurrentMonthLabel(currentLabel);
      setDateSelected(date);
      setEndDateSelected(date);
      setDatesView(items);
    };

    fetchData();
  }, []);

  const groupBy = (array, key, ...properties) => {
    // Return the end result    
    let groupedProps = {};
    properties.forEach(x => {
      groupedProps[x] = 0;
    });

    var res = [];
    array.reduce((result, currentValue) => {
      if (!result[currentValue[key]]) {
        result[currentValue[key]] = {
          ...groupedProps,
          id: currentValue[key],
        };
        res.push(result[currentValue[key]]);
      }
      for (let i = 0; i < properties.length; i++) {
        result[currentValue[key]][properties[i]] += currentValue[properties[i]];
      }
      return result;
    }, {});
    return res;
  };

  useEffect(() => {
    const fetchData = () => {
      connectApi.get("api/Channels", "", channelsLoad).catch((error) => {
        console.log(error);
        Swal.fire(
          "Error " + error?.response?.status,
          error?.response?.data,
          "error"
        );
      });
    };
    const channelsLoad = (status, data) => {
      const items = data.map((item) => {
        return {
          value: item.idCustomer,
          label: item.name,
        };
      });
      setChannelsView(items);
      setChannels(data);
      if (data.length == 1) {
        setChannelSelected(data[0].idCustomer);
      }
    };
    fetchData();
  }, []);
  const charge=()=>{
    if (EndDateSelected!=undefined && dateSelected!=undefined){
      if (new Date(dateSelected)<= new Date(EndDateSelected)){
        setIsLoading(true);
        connectApi
          .get(
            "api/Channels/bonusReport/",
            {
              params: {
                customerId: channelSelected,
                endUserId: null,
                startdate: dateSelected,
                Enddate: EndDateSelected
              },
            },
            dataResponseLoad
          )
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
            Swal.fire(
              "Error " + error?.response?.status,
              error?.response?.data,
              "error"
            );
          })
      }
      
    }
  }
  useEffect(() => {
    if (first==true){
      charge();
    }
  }, [dateSelected, channelSelected, EndDateSelected]);
  const dataResponseLoad = (status, data) => {
    setGroupBonusCustomers(groupBy(data.bonus, "customerName", "price", "creditNoteLastPublication", "releasedLastPublication", "onHoldLastPublication", "releasedPreviousPublication", "onHoldPreviousPublication", "creditNoteTotal", "creditNoteOnHoldTotal"));

    const bonusRegionCustomerGrouped = getGroupedCustomersRegionBonus(data.bonus);
    setGroupedCustomerRegionBonus(bonusRegionCustomerGrouped);
    setBonusTotals(getTotals(bonusRegionCustomerGrouped));

    setGroupCompensationCustomers(groupBy(data.compensation, "customerName", "compensationClient", "compensationChannel"));
    setGroupedCustomerRegionComp(getGroupedCustomerRegionCompensation(data.compensation));

    data.bonus.map((item) => {
      item.dateFormatted = moment(item.date).format("MMM/YYYY");
      item.tpiBonusFormatted =
        item.tpiBonus == null ? "" : numberFormatComma(item.tpiBonus);
      item.bonusAmountFormatted =
        item.bonusAmount == null
          ? ""
          : numberFormatComma(item.bonusAmount) + "%";
      item.priceFormatted =
        item.price == null ? "" : numberFormatCommaTwoFraction(item.price);
      item.creditNoteLastPublicationFormatted =
        item.creditNoteLastPublication == null
          ? ""
          : numberFormatCommaTwoFraction(item.creditNoteLastPublication);
      item.bonusAccepted =
        item.bonusAccepted == null ? "" : item.bonusAccepted;
      item.bonusPaid = item.bonusPaid == null ? "" : item.bonusPaid;
      if (item.specialCondition == null) {
        item.specialCondition = "";
      } else {
        item.specialCondition = item.specialCondition == 1 ? "Yes" : "No";
      }

      item.releasedLastPublicationFormatted =
        item.releasedLastPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.releasedLastPublication);

      item.onHoldLastPublicationFormatted =
        item.onHoldLastPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.onHoldLastPublication);

      item.releasedPreviousPublicationFormatted =
        item.releasedPreviousPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.releasedPreviousPublication);

      item.onHoldPreviousPublicationFormatted =
        item.onHoldPreviousPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.onHoldPreviousPublication);

      item.creditNoteTotalFormatted =
        item.creditNoteTotal == null ?
          "" :
          numberFormatCommaTwoFraction(item.creditNoteTotal);

      item.creditNoteOnHoldTotalFormatted =
        item.creditNoteOnHoldTotal == null ?
          "" :
          numberFormatCommaTwoFraction(item.creditNoteOnHoldTotal);

      item.bonusTotal =
        item.bonusTotal == null ?
          "" :
          numberFormatCommaTwoFraction(item.bonusTotal);
      item.bonusReleasedPreviousPublication =
        item.bonusReleasedPreviousPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.bonusReleasedPreviousPublication);
      item.bonusReleasedLastPublication =
        item.bonusReleasedLastPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.bonusReleasedLastPublication);    
      item.bonusOnHoldTotal =
        item.bonusOnHoldTotal == null ?
          "" :
          numberFormatCommaTwoFraction(item.bonusOnHoldTotal);   
      item.bonusOnHoldLastPublication =
        item.bonusOnHoldLastPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.bonusOnHoldLastPublication);    
      item.bonusOnHoldPreviousPublication =
        item.bonusOnHoldPreviousPublication == null ?
          "" :
          numberFormatCommaTwoFraction(item.bonusOnHoldPreviousPublication); 

    });

    let compensationClient = 0;
    let compensationChannel = 0;
    data.compensation.map((item) => {
      compensationChannel =
        item.compensationChannel == null
          ? compensationChannel
          : compensationChannel + item.compensationChannel;
      compensationClient =
        item.compensationClient == null
          ? compensationClient
          : compensationClient + item.compensationClient;
      item.dateFormatted = moment(item.date).format("MMM/YYYY");
      item.tpiCompensationFormatted =
        item.tpiCompensation == null
          ? ""
          : numberFormatCommaTwoFraction(item.tpiCompensation);
      item.compensationClientFormatted =
        item.compensationClient == null
          ? ""
          : numberFormatCommaTwoFraction(item.compensationClient);
      item.compensationChannelFormatted =
        item.compensationChannel == null
          ? ""
          : numberFormatCommaTwoFraction(item.compensationChannel);
    });
    setCompensationTotal({
      client: compensationClient,
      channel: compensationChannel,
    });
    setDataResponse(data);
    setDataBonus(data.bonus);
    setCompensationData(data.compensation);
    setTableData(data.bonus);
    setIsLoading(false);
    setfirst(false);
  };
  function getGroupedCustomersRegionBonus(data) {
    const groupedCustomer = groupBy(data, "customerName", "price", "creditNoteLastPublication", "releasedLastPublication", "onHoldLastPublication", "releasedPreviousPublication", "onHoldPreviousPublication", "creditNoteTotal", "creditNoteOnHoldTotal").filter(x => x.id != 'LAC - NOT ASSOCIATED W/CHANN');
    const groupedRegion = groupBy(data, "serviceArea", "price", "creditNoteLastPublication", "releasedLastPublication", "onHoldLastPublication", "releasedPreviousPublication", "onHoldPreviousPublication", "creditNoteTotal", "creditNoteOnHoldTotal").filter(x => x.id != '');

    //asign region to groupedCustomer
    groupedCustomer.forEach(item => {
      item.region = data[data.findIndex(x => x.customerName === item.id)].serviceArea;
    });

    groupedRegion.forEach(region => {
      region.customers = groupedCustomer.filter(cust => cust.region == region.id);
      region.id = 'Total ' + region.id;
    });

    let finalData = [];

    groupedRegion.forEach(region => {
      region.customers.forEach(cust => finalData.push(
        {
          id: cust.id,
          price: cust.price,
          creditNoteLastPublication: cust.creditNoteLastPublication,
          releasedLastPublication: cust.releasedLastPublication,
          onHoldLastPublication: cust.onHoldLastPublication,
          releasedPreviousPublication: cust.releasedLastPublication,
          onHoldPreviousPublication: cust.onHoldPreviousPublication,
          creditNoteTotal: cust.creditNoteTotal,
          creditNoteOnHoldTotal: cust.creditNoteOnHoldTotal,
          type: 'customer'
        }
      ));
      finalData.push(
        {
          id: region.id,
          price: region.price,
          creditNoteLastPublication: region.creditNoteLastPublication,
          releasedLastPublication: region.releasedLastPublication,
          onHoldLastPublication: region.onHoldLastPublication,
          releasedPreviousPublication: region.releasedLastPublication,
          onHoldPreviousPublication: region.onHoldPreviousPublication,
          creditNoteTotal: region.creditNoteTotal,
          creditNoteOnHoldTotal: region.creditNoteOnHoldTotal,
          type: 'region'
        }
      );
    });

    return finalData;
  }

  function getGroupedCustomerRegionCompensation(data) {
    const groupedCustomer = groupBy(data, "customerName", "compensationClient", "compensationChannel").filter(x => x.id != 'LAC - NOT ASSOCIATED W/CHANN');
    const groupedRegion = groupBy(data, "serviceArea", "compensationClient", "compensationChannel").filter(x => x.id != '');

    //asign region to groupedCustomer
    groupedCustomer.forEach(item => {
      item.region = data[data.findIndex(x => x.customerName === item.id)].serviceArea;
    });

    groupedRegion.forEach(region => {
      region.customers = groupedCustomer.filter(cust => cust.region == region.id);
      region.id = 'Total ' + region.id;
    });

    let finalData = [];

    groupedRegion.forEach(region => {
      region.customers.forEach(cust => finalData.push({ id: cust.id, compensationClient: cust.compensationClient, compensationChannel: cust.compensationChannel, type: 'customer' }));
      finalData.push({ id: region.id, compensationClient: region.compensationClient, compensationChannel: region.compensationChannel, type: 'region' });
    });

    return finalData;
  }

  const RenderChannelsList = () => {
    const handleSelectChange = (name) => (event) => {
      setChannelSelected(event.value);
      setCurrentPage(1);
    };

    return (
      <div
        style={{
          width: "350px",
          padding: "0.5% 2% ",
        }}
      >
        {t("channels")}
        <Select
          name="channel"
          onChange={handleSelectChange()}
          onClear={handleClearChannel()}
          options={channelsView}
          placeholder={<Trans i18nKey="channels" />}
          showSearch={false}
          value={[channelSelected]}
          disabled={channels.length == 1}
        />
      </div>
    );
  };

  const handleClearChannel = (name) => (event) => {
    setChannelSelected("whole");
  };

  const handleSort = (_, { id, type }) => {
      setOrderBy(id);
      setOrderType(type);
  };

  const renderCompensationOptions = () => {
    const handleStatusChange = (name) => (event) => {
      setCppType(event.value);
      setCurrentPage(1);
    };

    return (
      <div
        style={{
          width: "230px",
          padding: "0.5% 2% ",
        }}
      >
        {t("compensation")}
        <Select
          name="type"
          onChange={handleStatusChange()}
          options={[
            {
              value: "Compensation",
              label: <Trans i18nKey="compensation" />,
            },
            {
              value: "Bonus",
              label: <Trans i18nKey="bonus" />,
            },
          ]}
          value={[cppType]}
          clearIcon={false}
        ></Select>
      </div>
    );
  };
  const RenderEndDateList=()=>{
    const handleChange = (name) => (event) => {
      setEndDateSelected(event.value);
      setCurrentMonthLabel(event.label);
      setCurrentPage(1);
    };
    return (
      <div 
        style={{
          width: "230px",
          padding: "0.5% 2% ",
        }}
      >
        {t("specialcondition.enddate")}
        <Select
          name="Enddates"
          onChange={handleChange()}
          options={datesView}
          placeholder="End Date"
          value={[EndDateSelected]}
          clearIcon={false}
        />
      </div>
    );
  }
  const RenderDateList = () => {
    const handleChange = (name) => (event) => {
      setDateSelected(event.value);
      setCurrentMonthLabel(event.label);
      setCurrentPage(1);
    };

    return (
      <div
        style={{
          width: "230px",
          padding: "0.5% 2% ",
        }}
      >
        {t("specialcondition.startdate")}
        <Select
          name="dates"
          onChange={handleChange()}
          options={datesView}
          placeholder="Dates"
          value={[dateSelected]}
          clearIcon={false}
        />
      </div>
    );
  };

  function getTotals(bonusData) {
    let totals = {
      bonusAmount: 0,
      cnOnLastPublication: 0,
      cnReleasedOnLastPublication: 0,
      cnOnHoldOnLastPublication: 0,
      cnReleasedPreviousPublication: 0,
      cnOnHoldPreviousPublication: 0,
      cnTotal: 0,
      cnOnHoldTotal: 0,
    };

    bonusData.forEach(x => {
      if (x.id != "LAC - NOT ASSOCIATED W/CHANN" && !x.id.includes('Total') ) {
        totals.bonusAmount += x.price;
        totals.cnOnLastPublication += x.creditNoteLastPublication;
        totals.cnReleasedOnLastPublication += x.releasedLastPublication;
        totals.cnOnHoldOnLastPublication += x.onHoldLastPublication;
        totals.cnReleasedPreviousPublication += x.releasedPreviousPublication;
        totals.cnOnHoldPreviousPublication += x.onHoldPreviousPublication;
        totals.cnTotal += x.creditNoteTotal;
        totals.cnOnHoldTotal += x.creditNoteOnHoldTotal;
      }
    });

    return totals;
  }

  const getCompensationTotal = () => {
    var total = 0;
    groupCompensationCustomers.forEach((x) => {
      if (x.id != "LAC - NOT ASSOCIATED W/CHANN")
        total += x.compensationClient;
    });

    return total;
  };
  const reload=()=>{
    charge();
  }
  return (
    <div>
      <br />
      <h4>
        {" "}
        <Trans i18nKey="CostPerPrintBonusPer Channel" />
      </h4>
      <br />
      <div className="row" style={{ textAlign: "left", padding: "0.5%" }}>
        {RenderChannelsList()}
        {RenderDateList()}
        {RenderEndDateList()}
        {renderCompensationOptions()}
        <div
          style={{
          width: "350px",
          padding: "0.5% 2% ",
        }}
        >
          <br/>
          <Button
          onClick={reload}
            small={true} appearance="primary" 
            title="Reload">
            {t("reload")}
          </Button>
        </div>
        
      </div>
      <div>
        <br />
        <div
          style={{
            backgroundColor: "#f2f2f2",
            padding: "0.5%",
          }}
        >
          
          {cppType === "Bonus" ? (
            <div>
              <Table
                showFilters
                columnReorder
                columns={[
                  {
                    id: "dateFormatted",
                    label: t("month"),
                  },
                  {
                    id: "customerName",
                    label: <Trans i18nKey="channel" />,
                    filter: (
                      <Search
                        name="channelb-search"
                        value={channelFilterValue}
                        onChange={(val) => {
                          setChannelFilterValue(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "endUserNameLink",
                    label: <Trans i18nKey="Client" />,
                    index: true,
                    filter: (
                      <Search
                        id="endUserName-search"
                        value={endUserFilterValue}
                        onChange={(val) => {
                          setEndUserFilterValue(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  { id: "tpiBonusFormatted", label: "TPI-1SEP-2SEP-3SEP" },
                  {
                    id: "bonusAmountFormatted",
                    label: <Trans i18nKey="bonusPercentage" />,
                  },
                  {
                    id: "priceFormatted",
                    label: <Trans i18nKey="bonusAmount" />,
                  },
                  {
                    id: "creditNoteLastPublicationFormatted",
                    label: "Credit note on publication of " + currentMonthLabel,
                  },
                  {
                    id: "releasedLastPublicationFormatted",
                    label: "Credit note released on publication of " + currentMonthLabel
                  },
                  {
                    id: "releasedPreviousPublicationFormatted",
                    label: "Credit note released from previous publications"
                  },
                  {
                    id: "creditNoteTotalFormatted",
                    label: "Credit note to be paid total"
                  },
                  {
                    id: "onHoldLastPublicationFormatted",
                    label: "Credit note on hold on publication of " + currentMonthLabel
                  },
                  {
                    id: "onHoldPreviousPublicationFormatted",
                    label: "Credit note on hold from previous publications"
                  },
                  {
                    id: "creditNoteOnHoldTotalFormatted",
                    label: "Credit note on hold total"
                  },
                  {
                    id: "bonusAccepted",
                    label: <Trans i18nKey="bonus accepted" />,
                  },
                  {
                    id: "bonusPaid",
                    label: <Trans i18nKey="bonus paid" />,
                  },
                  {
                    id: "specialCondition",
                    label: <Trans i18nKey="special condition" />,
                  },
                  {
                    id:"bonusReleasedLastPublication",
                    label : <Trans i18nKey="bonus released last publication"/>
                  },
                  {
                    id:"bonusOnHoldLastPublication",
                    label:  <Trans i18nKey="bonus on hold last publication"/>
                  },
                  {
                    id:"bonusReleasedPreviousPublication",
                    label:  <Trans i18nKey="bonus release previous publication"/>
                  },
                  {
                    id:"bonusOnHoldPreviousPublication",
                    label: <Trans i18nKey="bonus on hold previous publication"/>
                  },
                  {
                    id:"bonusOnHoldTotal",
                    label:<Trans i18nKey="bonus on hold total"/>
                  },
                  {
                    id:"bonusTotal",
                    label:<Trans i18nKey="bonus total"/>
                  },
                  {
                    id: "serviceArea",
                    label: <Trans i18nKey="region" />,
                    filter: (
                      <Search
                        name="region-search"
                        value={regionFilterValue}
                        onChange={(val) => {
                          setRegionFilterValue(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                ]}
                data={pagedData}
                onColumnReorder={handleOnColumnReorder}
                onSort={handleSort}
                loading={isLoading}
                behavior={{ type: 'singlePage', offset: { top: 0, bottom: 50 } }}
                preferences={{
                  defaultOrder: config.map((c) => c.id),
                  order,
                  sortBy: {
                    id: orderBy,
                    type: orderType,
                  },
                  width: [
                    {
                      columnId: 'dateFormatted', width: 80
                    },
                    {
                      columnId: 'customerName', width: 230
                    },
                    {
                      columnId: 'endUserNameLink', width: 230
                    },
                    {
                      columnId: 'tpiBonusFormatted', width: 100
                    },
                    {
                      columnId: 'bonusAmountFormatted', width: 100
                    },
                    {
                      columnId: 'priceFormatted', width: 100
                    },
                    {
                      columnId: 'creditNoteLastPublicationFormatted', width: 100
                    },
                    {
                      columnId: 'releasedLastPublicationFormatted', width: 100
                    },
                    {
                      columnId: 'releasedPreviousPublicationFormatted', width: 100
                    },
                    {
                      columnId: 'creditNoteTotalFormatted', width: 100
                    },
                    {
                      columnId: 'onHoldLastPublicationFormatted', width: 100
                    },
                    {
                      columnId: 'onHoldPreviousPublicationFormatted', width: 100
                    },
                    {
                      columnId: 'creditNoteOnHoldTotalFormatted', width: 100
                    },
                    {
                      columnId: 'bonusAccepted', width: 100
                    },
                    {
                      columnId: 'bonusPaid', width: 100
                    },
                    {
                      columnId: 'specialCondition', width: 100
                    },
                    {
                      columnId: 'bonusReleasedLastPublication', width: 100
                    },
                    {
                      columnId: 'bonusOnHoldLastPublication', width: 100
                    },
                    {
                      columnId: 'bonusReleasedPreviousPublication', width: 100
                    },
                    {
                      columnId: 'bonusOnHoldPreviousPublication', width: 100
                    },
                    {
                      columnId: 'bonusOnHoldTotal', width: 100
                    },
                    {
                      columnId: 'bonusTotal', width: 100
                    },
                    {
                      columnId: 'serviceArea', width: 80
                    },
                  ]
                }}
                pagination={{
                  currentPage,
                  onPageChange: handlePageChange,
                  pageSize,
                  totalItems: filteredData.length,
                }}
                css={{
                  "tr > td:nth-of-type(4)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(5)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(6)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(7)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(8)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(9)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(10)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(11)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(12)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(13)": {
                    textAlign: "right",
                  },
                  "tr > td:nth-of-type(14)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(15)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(16)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(17)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(18)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(19)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(20)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(21)": {
                    textAlign: "center",
                  },
                  "tr > td:nth-of-type(21)": {
                    textAlign: "center",
                  },
                }}
              ></Table>
              <div style={{ textAlign: "left" }}>
                <Button
                  leadingIcon={<IconDownload />}
                  onClick={() => {
                    exportData();
                  }}
                  disabled={tableData === 0}
                  loading={loadingExport}
                  title={t('download data')}
                >
                  {t('download')}
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <Table
                showFilters
                columnReorder
                columns={[
                  {
                    id: "dateFormatted",
                    label: t("month"),
                  },
                  {
                    id: "customerName",
                    label: t("channel"),
                    filter: (
                      <Search
                        id="channel-search"
                        onChange={(val) => {
                          setCustomerNameCompensation(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "endUserNameLink",
                    label: t("Client"),
                    index: true,
                    filter: (
                      <Search
                        id="endUserName-search"
                        onChange={(val) => {
                          setEndUserNameCompensation(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  { id: "tpiCompensationFormatted", label: "TPI-1SEP-2SEP-3SEP" },
                  {
                    id: "serviceArea",
                    label: t("region"),
                  },
                  {
                    id: "compensationClientFormatted",
                    label: t("balancereport.compclient"),
                  },
                  { id: "compensationChannelFormatted", label: t("compchannel") },
                  {
                    id: "compensationAccepted",
                    label: t("compensationAccepted"),
                  },
                ]}
                data={pagedCompensationData}
                onColumnReorder={handleOnColumnReorder}
                onSort={handleSort}
                loading={isLoading}
                behavior={{ type: 'singlePage', offset: { top: 0, bottom: 50 } }}
                preferences={{
                  defaultOrder: configCompensation.map((c) => c.id),
                  orderCompensation,
                  sortBy: {
                    id: orderBy,
                    type: orderType,
                  },
                  width: [
                    {
                      columnId: 'dateFormatted', width: 80
                    },
                    {
                      columnId: 'customerName', width: 250
                    },
                    {
                      columnId: 'endUserNameLink', width: 260
                    },
                    {
                      columnId: 'tpiCompensationFormatted', width: 150
                    },
                    {
                      columnId: 'serviceArea', width: 100
                    },
                    {
                      columnId: 'compensationClientFormatted', width: 120
                    },
                    {
                      columnId: 'compensationChannelFormatted', width: 120
                    },
                    {
                      columnId: 'compensationAccepted', width: 120
                    },
                  ]
                }}
                pagination={{
                  currentPage: currentCompensationPage,
                  onPageChange: handlePageCompensationChange,
                  pageSize,
                  totalItems: filteredCompensationData.length,
                }}
              ></Table>
              <div style={{ textAlign: "left" }}>
                <Button
                  leadingIcon={<IconDownload />}
                  onClick={() => {
                    exportData();
                  }}
                  disabled={tableData === 0}
                  loading={loadingExport}
                  title={t('download data')}
                >
                  {t('download')}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <br />
      
      {(dateSelected===EndDateSelected)?(
          <div className="table-wrapper">
          <Row>
            <Col md="12" lg="8">
              {cppType === "Compensation" ? (
                groupCompensationCustomers.length > 0 ? (
                  <div>
                    <div className="card-header text-center">
                      <h5>Total</h5>
                    </div>
                    <table
                      className="table table-striped table-hover table-bordered table-sm table-fit"
                      style={{ maxWidth: "100%", minWidth: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th scope="col" className="text-center">
                            {t("channel")}
                          </th>
                          <th scope="col" className="text-center">
                            {t("compensation")} {t("Client")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {channelSelected === 'whole' ? (
                          groupedCustomerRegionComp.map((row, key) => {
                            if (row.id != "LAC - NOT ASSOCIATED W/CHANN") {
                              return (
                                <tr style={row.type === 'region' ? { backgroundColor: '#caf3ff' } : undefined}>
                                  <th colSpan="1" scope="row" className="text-right">
                                    {row.id.toUpperCase()}
                                  </th>
                                  <td className="text-right" scope="row">
                                    US $
                                    {numberFormatCommaTwoFraction(
                                      row.compensationClient
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                          })
                        ) : (
                          groupCompensationCustomers.map((row, key) => {
                            if (row.id != "LAC - NOT ASSOCIATED W/CHANN") {
                              return (
                                <tr>
                                  <th colSpan="1" scope="row" className="text-right">
                                    {row.id}
                                  </th>
                                  <td className="text-right" scope="row">
                                    US $
                                    {numberFormatCommaTwoFraction(
                                      row.compensationClient
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                          })
                        )}
                        {channelSelected === "whole" ? (
                          <tr>
                            <th colSpan="1" scope="row" className="text-right">
                              TOTAL
                            </th>
                            <td className="text-right" scope="row">
                              US $
                              {numberFormatCommaTwoFraction(getCompensationTotal())}
                            </td>
                          </tr>
                        ) : (
                          ""
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : undefined
              ) : groupBonusCustomers.length > 0 ? (
                <div className="card-deck ">
                  <br />
                  <br />
                  <br />
                  <div className="card  box-shadow">
                    <div className="card-header text-center">
                      {channelSelected === "whole" ? (
                        <h5>Total</h5>
                      ) : (
                        <h5>
                          {t("credit note")}{" "}
                          {dataResponse?.creditNote?.invoiceId == undefined ||
                            dataResponse?.creditNote?.invoiceId == null
                            ? ""
                            : "- " +
                            t("Focus ID") +
                            ": " +
                            dataResponse?.creditNote?.invoiceId}
                        </h5>
                      )}
                    </div>
                    <div style={{ padding: "0px" }} className="card-body">
                      <div>
                        <table className="table table-striped table-hover table-bordered table-sm ">
                          <thead>
                            <tr>
                              <th scope="col" className="text-center">
                                {t("channel")}
                              </th>
                              <th scope="col" className="text-center">
                                {t("bonusAmount")}
                              </th>
                              <th scope="col" className="text-center">
                                {t("Credit note on publication of") + currentMonthLabel}
                              </th>
                              <th scope="col" className="text-center">
                                {t("Credit note to be paid total")}
                              </th>
                              <th scope="col" className="text-center">
                                {t("Credit note on hold total")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {channelSelected === 'whole' ? (
                              groupedCustomerRegionBonus?.map((row, key) => {
                                if (row.id != "LAC - NOT ASSOCIATED W/CHANN") {
                                  return (
                                    <tr style={row.type === 'region' ? { backgroundColor: '#caf3ff' } : undefined}>
                                      <th
                                        colSpan="1"
                                        scope="row"
                                        className="text-right"
                                      >
                                        {row.id.toUpperCase()}
                                      </th>
                                      <td className="text-right" scope="row">
                                        US ${numberFormatCommaTwoFraction(row.price)}
                                      </td>
                                      <td className="text-right" scope="row">
                                        US $
                                        {numberFormatCommaTwoFraction(row.creditNoteLastPublication)}
                                      </td>
                                      <td className="text-right" scope="row">
                                        US $
                                        {numberFormatCommaTwoFraction(row.creditNoteTotal)}
                                      </td>
                                      <td className="text-right" scope="row">
                                        US $
                                        {numberFormatCommaTwoFraction(row.creditNoteOnHoldTotal)}
                                      </td>
                                    </tr>
                                  );
                                }
                              })
                            ) : (
                              groupBonusCustomers?.map((row, key) => {
                                if (row.id != "LAC - NOT ASSOCIATED W/CHANN") {
                                  return (
                                    <tr>
                                      <th
                                        colSpan="1"
                                        scope="row"
                                        className="text-right"
                                      >
                                        {row.id}
                                      </th>
                                      <td className="text-right" scope="row">
                                        US ${numberFormatCommaTwoFraction(row.price)}
                                      </td>
                                      <td className="text-right" scope="row">
                                        US $
                                        {numberFormatCommaTwoFraction(row.creditNoteLastPublication)}
                                      </td>
                                      <td className="text-right" scope="row">
                                        US $
                                        {numberFormatCommaTwoFraction(row.creditNoteTotal)}
                                      </td>
                                      <td className="text-right" scope="row">
                                        US $
                                        {numberFormatCommaTwoFraction(row.creditNoteOnHoldTotal)}
                                      </td>
                                    </tr>
                                  );
                                }
                              })
                            )}
                            {channelSelected === "whole" ? (
                              <tr>
                                <th colSpan="1" scope="row" className="text-right">
                                  TOTAL
                                </th>
                                <td className="text-right" scope="row">
                                  US $
                                  {numberFormatCommaTwoFraction(bonusTotals?.bonusAmount ?? 0)}
                                </td>
                                <td className="text-right" scope="row">
                                  US $
                                  {numberFormatCommaTwoFraction(bonusTotals?.cnOnLastPublication ?? 0)}
                                </td>
                                <td className="text-right" scope="row">
                                  US $
                                  {numberFormatCommaTwoFraction(bonusTotals?.cnTotal ?? 0)}
                                </td>
                                <td className="text-right" scope="row">
                                  US $
                                  {numberFormatCommaTwoFraction(bonusTotals?.cnOnHoldTotal ?? 0)}
                                </td>
                              </tr>
                            ) : (
                              dataResponse?.creditNote?.afterAdjustmentBonus != undefined && dataResponse?.creditNote?.afterAdjustmentCNLastPublication != undefined &&
                                (dataResponse?.creditNote?.afterAdjustmentBonus != dataResponse?.creditNote?.bonusClient ||
                                  dataResponse?.creditNote?.afterAdjustmentCNLastPublication != dataResponse?.creditNote?.creditNoteLastPublication) ? (
                                <tr>
                                  <th colSpan="1" scope="row" className="text-right">
                                    {t("bonusReport.totalAfterAdjustment")}
                                  </th>
                                  <td className="text-right" scope="row">
                                    US $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.afterAdjustmentBonus ??
                                      0
                                    )}
                                  </td>
                                  <td className="text-right" scope="row">
                                    US $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.afterAdjustmentCNLastPublication ??
                                      0
                                    )}
                                  </td>
                                  <td className="text-right" scope="row">
                                    US $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.afterAdjustmentCNTotal ??
                                      0
                                    )}
                                  </td>
                                  <td className="text-right" scope="row">
                                    US $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.afterAdjustmentCNOnHoldTotal ??
                                      0
                                    )}
                                  </td>
                                </tr>
                              ) : undefined
                            )}
                            {channelSelected != "whole" &&
                              dataResponse?.creditNote?.exchangeRate > 0 ? (
                              <>
                                <tr>
                                  <th colSpan="1" scope="row" className="text-right">
                                    {t("bonusReport.totalInReals")} (R$)
                                  </th>
                                  <td className="text-right" scope="row">
                                    R $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.bonusReal ?? 0
                                    )}
                                  </td>
                                  <td className="text-right" scope="row">
                                    R $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.cnLastPublicationReals ?? 0
                                    )}
                                  </td>
                                  <td className="text-right" scope="row">
                                    R $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.cnTotalReals ?? 0
                                    )}
                                  </td>
                                  <td className="text-right" scope="row">
                                    R $
                                    {numberFormatCommaTwoFraction(
                                      dataResponse?.creditNote?.cnOnHoldTotalReals ?? 0
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th colSpan="1" scope="row" className="text-right">
                                    {t("exchangeRate")}
                                  </th>
                                  <td colSpan="7" className="text-right" scope="row">
                                    {dataResponse?.creditNote?.exchangeRate ?? 0}
                                  </td>
                                </tr>
                              </>
                            ) : undefined}
                          </tbody>
                        </table>
                      </div>
                      <div>
                        {channelSelected === "whole" ||
                          dataResponse?.creditNote?.creditNoteDetailsList == null ||
                          dataResponse?.creditNote?.creditNoteDetailsList.length ==
                          0 ? undefined : (
                          <>
                            <div className="card-header text-center">
                              <h5>{t("adjustments")}</h5>
                            </div>
                            <table className="table table-striped table-hover table-bordered table-sm ">
                              <thead>
                                <tr>
                                  <th scope="col" className="text-center">
                                    {t("month")}
                                  </th>
                                  <th scope="col" className="text-center">
                                    {t("Client")}
                                  </th>
                                  <th scope="col" className="text-center">
                                    {t("credit note")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {dataResponse?.creditNote?.creditNoteDetailsList?.map(
                                  (row, key) => {
                                    return (
                                      <tr>
                                        <td
                                          colSpan="1"
                                          scope="row"
                                          className="text-right"
                                        >
                                          {moment(row.date).format("YYYY-MM")}
                                        </td>
                                        <td className="text-right" scope="row">
                                          {row.endUserName}
                                        </td>
                                        <td className="text-right" scope="row">
                                          US $
                                          {numberFormatCommaTwoFraction(
                                            row.creditNoteLastPublication
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : undefined}
            </Col>
          </Row>
        </div>
      ):("")}
      
    </div>
  );
};

export default DetailsStatement;
